(function (ws, win) {
    'use strict';

    ws.views.rfqSubmitSuccessModal = ws.views.modal.extend({
        /**
         * Events override
         */
        events: _.extend({}, ws.views.modal.prototype.events, {
            'click .rfq-submit-ok': 'disableNavigateAlert'
        }),

        /**
         * Disable navigate alert
         * @param {*} e
         */
        disableNavigateAlert: function(e) {
            var $el = $(e.currentTarget);
            $el.addClass('disabled spinner-before no-padding');
            $el.prop('disabled', true);
            win.onbeforeunload = null;
        }
    });
})(westcon, window);
